import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=48d6d631"
import script from "./ModalComment.vue?vue&type=script&lang=js"
export * from "./ModalComment.vue?vue&type=script&lang=js"
import style0 from "./ModalComment.vue?vue&type=style&index=0&id=48d6d631&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports